// Mirrors backend enum ProductGroupId (credit's product group).
const ProductGroupId = {
  None: 0,
  Coaching: 1,
  Bundle: 2,
};

// Human-readable labels keyed by numeric value. None = plain premium credit.
export const ProductGroupIdLabels = {
  0: "Premium",
  1: "Koçluk",
  2: "Paket",
};

export const getProductGroupLabel = (id) => {
  const key = Number(id);
  return ProductGroupIdLabels[key] !== undefined
    ? ProductGroupIdLabels[key]
    : String(id);
};

export default ProductGroupId;
